
import validator from 'validator';

const validateEditAdmin = (data) => {
    let errors = {};

    const { name, email, phone } = data;

    if (validator.isEmpty(name)) {
        errors.name = '이름은 필수 항목입니다..';
    }

    if (validator.isEmpty(email)) {
        errors.email = '이메일이 필요합니다';
    } else if (!validator.isEmail(email)) {
        errors.email = '잘못된 이메일 주소입니다.';
    }
    if (!phone) {
        errors.phone = '전화번호가 필요합니다.';
    } else if (phone.length < 9) {
        errors.phone = '올바른 핸드폰번호를 입력해 주세요.';
    }
    // if (validator.isEmpty(menus)) {
    //     errors.menus = '권한 선택';
    // }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default validateEditAdmin;
